import * as THREE from 'three'

import Sizes from './Utils/Sizes'
import Time from './Utils/Time'
import Resources from './Utils/Resources'
import Debug from './Utils/Debug'

import Camera from './Camera'
import Renderer from './Renderer'
import World from './World/World'

import sources from './sources'
import Events from './Event/Events'

let instance = null
export default class Experience {
  constructor(canvas) {
    //Instance
    if (instance) {
      return instance
    }
    instance = this

    //global acces
    window.experience = this

    //options
    this.canvas = canvas

    //setup
    this.sizes = new Sizes()
    this.time = new Time()
    this.scene = new THREE.Scene()
    this.resources = new Resources(sources)
    this.debug = new Debug()
    this.camera = new Camera()
    this.renderer = new Renderer()
    this.world = new World()
    this.event = new Events()

    //Sizes resize event
    this.sizes.on('resize', this.resize.bind(this))

    //Time update event
    this.time.on('tick', this.update.bind(this))
  }

  resize() {
    this.camera.resize()
    this.renderer.resize()
  }
  update() {
    this.camera.update()
    this.world.update()
    this.renderer.update()
  }
  destroy() {
    this.sizes.off('resize')
    this.time.off('tick')

    //Traverse the scene
    this.scene.traverse(child => {
      //test if it's a mesh
      if (child instanceof THREE.Mesh) {
        child.geometry.dispose()

        //loop trhought keys
        for (const key in child.material) {
          const value = child.material[key]

          if (value && typeof value.dipose === 'function') {
            value.dispose()
          }
        }
      }
    })

    this.camera.controls.dispose()
    this.renderer.instance.dispose()

    if (this.debug) {
      this.debug.ui.destroy()
    }
  }
}
